import { render, staticRenderFns } from "./AiAnalysisSection.vue?vue&type=template&id=4f9b8905&scoped=true"
import script from "./AiAnalysisSection.vue?vue&type=script&lang=js"
export * from "./AiAnalysisSection.vue?vue&type=script&lang=js"
import style0 from "./AiAnalysisSection.vue?vue&type=style&index=0&id=4f9b8905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b8905",
  null
  
)

export default component.exports